export const formatPrice = (
  price: number,
  currency: string,
  digits: number = 2
) => `${currency}${price.toFixed(digits)}`;
